<template>
  <div class="layout">
    <div class="add-live" :style="{ height: wrapHeight + 'px' }">
      <cube-form :model="model" @submit="submitHandler">
        <cube-form-group>
          <cube-form-item :field="fields[0]">
            <cube-input
              v-model="model.title"
              placeholder="请输入直播标题"
              :disabled="btnDisable"
              type="text"
              :maxlength="maxlength"
            ></cube-input>
          </cube-form-item>
          <cube-form-item :field="fields[1]">
            <cube-input
              v-model="model.userName"
              placeholder="请输入预约教师"
              :disabled="btnDisable"
              type="text"
            ></cube-input>
          </cube-form-item>
          <cube-form-item :field="fields[3]">
            <cube-input
              v-model="model.mobile"
              placeholder="请输入手机号"
              :disabled="btnDisable"
              type="text"
            ></cube-input>
          </cube-form-item>
          <cube-form-item :field="fields[2]">
            <div class="item" @click="showTimePicker">
              {{ model.endTime || '选择时间' }}
              <svg-icon icon-class="right"></svg-icon>
            </div>
          </cube-form-item>
          <cube-form-item :field="fields[4]">
            <cube-switch v-model="model.isComment"> </cube-switch>
          </cube-form-item>
        </cube-form-group>
        <cube-form-group class="btn">
          <cube-button class="btn-submit" :disabled="btnDisable" :primary="true" type="submit"
            >开启</cube-button
          >
        </cube-form-group>
      </cube-form>
    </div>
    <loading v-if="isLoading" />
    <share-login ref="popup" />
  </div>
</template>

<script>
import format from 'date-fns/format';
import addMinutes from 'date-fns/add_minutes';
import liveApi from '@/api/live';
import backMixin from '@/mixins/back';
import loadingMixin from '@/mixins/loading';
import { mapGetters } from 'vuex';
import { generateDuration } from '@/utils/index';
import { character, isMobile } from '@/utils/const';
import Loading from '@/components/Loading/Index.vue';
import ShareLogin from '@/pages/ShareLogin/index.vue';

const duration = generateDuration(30, 120, 5);
const liveType = [
  {
    text: '录播主机',
    value: '1'
  },
  {
    text: '精品直播',
    value: '2'
  }
];

export default {
  name: 'live-add',
  components: {
    Loading,
    ShareLogin
  },
  data() {
    return {
      wrapHeight: 400,
      maxlength: 51,
      liveTitle: '预约直播',
      validity: {},
      valid: undefined,
      btnDisable: false,
      model: {
        title: '',
        userName: '',
        mobile: '',
        deviceUuid: '',
        endTime: '',
        timeText: duration[0].text,
        timeValue: duration[0].value,
        liveType: liveType[0].text,
        liveTypeValue: liveType[0].value,
        isComment: true
      },
      timeLength: duration,
      liveType,
      fields: [
        {
          modelKey: 'title',
          label: '直播标题',
          rules: {
            required: true,
            // pattern: character,
            max: 50
          },
          // messages: {
          //   pattern: '直播标题不能包含特殊字符'
          // }
        },
        {
          modelKey: 'userName',
          label: '预约教师',
          rules: {
            required: true,
            pattern: character,
            max: 10
          },
          messages: {
            pattern: '教师名称不能包含特殊字符'
          }
        },
        {
          modelKey: 'endTime',
          label: '结束时间',
          rules: {
            required: true
          }
        },
        {
          modelKey: 'mobile',
          label: '手机号',
          rules: {
            required: true,
            pattern: isMobile,
            max: 11
          },
          messages: {
            pattern: '请输入正确的手机号'
          }
        },
        {
          modelKey: 'isComment',
          label: '评论',
          rules: {
            required: true
          }
        }
      ],
      deviceUuid: '',
      pcUuid: ''
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'schoolName'])
  },
  mixins: [backMixin, loadingMixin],

  mounted() {
    this.deviceUuid = this.$route.query.deviceUuid ? this.$route.query.deviceUuid : '';

    this.pcUuid = this.$route.query.pcUuid ? this.$route.query.pcUuid : '';

    this.line_id = this.$route.query.line_id ? this.$route.query.line_id : '';

    this.wrapHeight = this.$calcWrapHeight();
    this.initData();
    this.checkLogin();
    document.title = '开启直播';
  },

  watch: {
    model(newV) {
      if (newV.title.length > 20) {
        const newV1 = newV.title.slice(0, 20);
        this.$nextTick(() => {
          this.model.title = newV1;
        });
      }
    }
  },
  methods: {
    submitHandler(e) {
      e.preventDefault();
      const startTimes = format(Date.now(), 'YYYY-MM-DD HH:mm:00');
      const endTimes = format(this.model.endTime, 'YYYY-MM-DD HH:mm:00');
      const params = {
        title: this.model.title,
        userPhone: this.model.mobile,
        userName: this.model.userName,
        // deviceUuid: this.model.deviceUuid,
        // liveType: '4',
        schoolName: this.schoolName,
        coverPath: '',
        liveDescription: this.model.title,
        livePassword: '',
        startTime: startTimes,
        endTime: endTimes,
        allowComments: this.model.isComment ? '1' : '0' // 0:否，1：是
      };

      this.changeLoadingStatus(true);
      this.btnDisable = true;
      // 预约直播
      if (this.deviceUuid && this.deviceUuid !== '') {
        params.deviceUuid = this.model.deviceUuid;
        params.liveType = '4';
        if (this.line_id !== '') {
          params.line_id = this.line_id;
        }
        liveApi
          .addCodeLiveRoom(params)
          .then(response => {
            console.log('response.result.data6666666666:', response.result.data);
            if (response.code === 0 && response.result.flag === 0) {
              this.$createToast({
                txt: '直播预约成功',
                type: 'correct'
              }).show();
              // 用于添加成功后，返回列表页，重新获取数据
              this.$route.meta.addSucess = true;
              // this.goBack();
              // 跳转到分享页面
              this.$store.commit('SET_LIVE_INFO', response.result.data);
              this.$router.push(
                `/share?liveId=${response.result.data.liveId}&schoolName=${
                  response.result.data.schoolName
                }&streamStatus=${response.result.data.streamStatus}&mobile=${
                  response.result.data.userPhone
                }`
              );
            } else {
              let errorMsg = '预约失败';
              if (response.result.flag === 1) {
                errorMsg = '同一时间段，超出直播预约数量，请联系管理员';
              }
              if (response.result.flag === 2) {
                errorMsg = '预约任务创建失败，请联系管理员';
              }
              if (response.result.flag === 3) {
                errorMsg = '请先在爱学班班注册后，再次登录';
              }
              if (response.result.flag === 4) {
                errorMsg = '云平台错误，请联系管理员';
              }
              this.$createToast({
                txt: errorMsg,
                type: 'error'
              }).show();
              this.changeLoadingStatus(false);
              this.btnDisable = false;
              return;
            }
            this.changeLoadingStatus(false);
            this.btnDisable = false;
          })
          .catch(err => {
            console.log('addLiveByphone-err', err);
            this.changeLoadingStatus(false);
            this.btnDisable = false;
            if (err.indexOf('504') != -1) {
              this.$createToast({
                txt: '服务器响应超时，请重试',
                type: 'error'
              }).show();
            }
          });
      } else {
        params.liveType = '5';
        params.activity = '';
        params.activityFlag = '';
        params.pcUuid = this.pcUuid;
        liveApi
          .saveLiveRoom(params)
          .then(response => {
            if (response.code === 0 && response.result.flag === 0) {
              this.$createToast({
                txt: '直播预约成功',
                type: 'correct'
              }).show();
              // 用于添加成功后，返回列表页，重新获取数据
              this.$route.meta.addSucess = true;
              // this.goBack();
              // 跳转到分享页面
              this.$store.commit('SET_LIVE_INFO', response.result.data);
              this.$router.push(
                `/share?liveId=${response.result.data.liveId}&schoolName=${
                  response.result.data.schoolName
                }&streamStatus=${response.result.data.streamStatus}&mobile=${
                  response.result.data.userPhone
                }`
              );
            } else {
              let errorMsg = '预约失败';
              if (response.result.flag === 1) {
                errorMsg = '同一时间段，超出直播预约数量，请联系管理员';
              }
              if (response.result.flag === 2) {
                errorMsg = '预约任务创建失败，请联系管理员';
              }
              this.$createToast({
                txt: errorMsg,
                type: 'error'
              }).show();
              this.changeLoadingStatus(false);
              this.btnDisable = false;
              return;
            }
            this.changeLoadingStatus(false);
            this.btnDisable = false;
          })
          .catch(err => {
            this.changeLoadingStatus(false);
            this.btnDisable = false;
            if (err.indexOf('504') != -1) {
              this.$createToast({
                txt: '服务器响应超时，请重试',
                type: 'error'
              }).show();
            }
          });
      }
    },
    initData() {
      this.model.userName = this.userInfo.realname;
      this.model.deviceUuid = this.$route.query.deviceUuid ? this.$route.query.deviceUuid : '';
      this.model.endTime = format(addMinutes(new Date(), 40), 'YYYY-MM-DD HH:mm');
      this.model.mobile = localStorage.getItem('mobile');
      // this.model.startTime = format(addMinutes(new Date(), 10), 'YYYY-MM-DD HH:mm');
    },
    showTimeLengthPicker() {
      if (!this.timeLengthPicker) {
        this.timeLengthPicker = this.$createPicker({
          title: '选择时长',
          data: [this.timeLength],
          onSelect: this.selectTimeHandle,
          onCancel: this.cancelTimeHandle
        });
      }
      this.timeLengthPicker.show();
    },
    selectTimeHandle(selectedVal, selectedIndex, selectedText) {
      this.model.timeText = selectedText.join('');
      this.model.timeValue = selectedVal.join('');
    },
    showTimePicker() {
      if (!this.btnDisable) {
        this.$createTimePicker({
          showNow: false,
          minuteStep: 5,
          delay: 15,
          day: {
            len: 5,
            filter: ['今天'],
            format: 'YYYY-MMM-dd'
          },
          max: +new Date() + 60 * 24 * 60 * 60 * 1000,
          format: 'YYYY-MM-DD HH:mm',
          onSelect: (selectedTime, selectedText, formatedTime) => {
            this.model.endTime = formatedTime;
          }
        }).show();
      }
    },
    showTypePicker() {
      if (!this.typePicker) {
        this.typePicker = this.$createPicker({
          title: '选择类型',
          data: [this.liveType],
          onSelect: this.selectTypeHandle
        });
      }
      this.typePicker.show();
    },
    selectTypeHandle(selectedVal, selectedIndex, selectedText) {
      this.model.liveType = selectedText.join('');
      this.model.liveTypeValue = selectedVal.join('');
    },
    checkLogin() {
      if (!window.localStorage) {
        alert('浏览器不支持localstorage');
      } else {
        const currentTime = new Date().getTime();
        const storage = window.localStorage;
        if (!storage.mobile || currentTime >= storage.outTime) {
          this.logined = false;
          window.localStorage['mobile'] = '';
          // 需要登录
          this.$refs.popup.show(false, this.model.deviceUuid);
          return;
        }
      }
    }
  }
};
</script>

<style lang="less">
.add-live {
  // padding-top: 10px;

  .cube-form {
    font-size: 14px;
    line-height: 1.429;

    .item {
      display: flex;
      justify-content: space-between;

      .svg-icon {
        color: #666;
      }
    }

    .cube-validator-content {
      color: #000;
    }
  }

  .btn {
    background-color: #f6f7f8;
    // background-color: rgb(255,102,0);
  }

  .cube-btn-primary {
    // background-color: rgb(255, 102, 0);
    background-color: #1890ff;
  }

  .btn-submit {
    width: 345px;
    margin: 40px auto 0;
  }
}
</style>
